import { SharingDraft } from '@/types';
import { SharingLinks } from '@/utils/sharing';

export interface UserDraftsState {
  drafts: AugmentedSharingDraft[];
  selectedDraft?: AugmentedSharingDraft;
  activeDraft?: ActiveDraft;
}

export interface AugmentedSharingDraft {
  userDraft: SharingDraft;
  publicDraft?: SharingDraft;
  shareUrls?: SharingLinks;
  isDeleted?: boolean;
}

export interface ActiveDraft {
  id: string;
  name: string;
}

export enum UserDraftsActionTypes {
  SET_DRAFTS = '@userDrafts/drafts/set',
  SET_DRAFT = '@userDrafts/draft/set',
  SET_ACTIVE_DRAFT = '@userDrafts/activeDraft/set',
  DELETE_ACTIVE_DRAFT = '@userDrafts/activeDraft/delete',
}

export interface SetDraftsAction {
  type: UserDraftsActionTypes.SET_DRAFTS;
  drafts: AugmentedSharingDraft[];
}

export interface SetDraftAction {
  type: UserDraftsActionTypes.SET_DRAFT;
  draft: AugmentedSharingDraft;
}

export interface SetActiveDraftAction {
  type: UserDraftsActionTypes.SET_ACTIVE_DRAFT;
  id: string;
  name: string;
}

export interface DeleteActiveDraftAction {
  type: UserDraftsActionTypes.DELETE_ACTIVE_DRAFT;
}

export type UserDraftsAction =
  | SetDraftsAction
  | SetDraftAction
  | SetActiveDraftAction
  | DeleteActiveDraftAction;
